<template>
  <el-header class="header">
    <div class="eiga-header noprint">
      <section class="logo">
          <router-link :to="{ name: 'dashboard' }">
            <img src="@/assets/img/login-logo.png" alt="Ticketing Logo" />
          </router-link>
      </section>
      <section class="nav-bar">
        <!-- <Notification :isHeaderShow="isHeaderShow"></Notification> -->
        <div class="help-link">
          <router-link :to="{ name: 'help' }">
            {{ $locale("global.needHelps") }}？
          </router-link>
        </div>
        <div class="drop-down-menu">
          <el-menu class="el-menu-title" mode="horizontal">
            <el-submenu index="1" v-if="isLoginPage">
              <template slot="title">
                <el-avatar :size="30" class="user-avatar">
                  <img src="@/assets/user.jpg" alt="User Avatar" />
                </el-avatar>
                <span class="user-name">{{ userName }}</span>
              </template>
              <el-menu-item @click="backToOriginalAdmin" index="1--1" v-if="originalAdmin">{{ originalAdmin }} {{ $locale("global.backTo") }}</el-menu-item>
              <el-menu-item @click="logout" index="1-1">{{
                $locale("global.logout")
              }}</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </section>
    </div>
  </el-header>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { localStorage } from "@/utils/localStorage";
import { loginAsBrand } from "@/helpers/service/api/brand.js";
import { logoutService,getSystemSetting } from "@/helpers/service/api/common";
import { setLocalStorage } from "@/assets/js/storage";
// import Notification from "./Notification";

export default {
  name: "eiga-header",
  // components: {
  //   Notification,
  // },
  props: {
    isHeaderShow: {
      type: Boolean,
    },
  },
  data() {
    return {
      logoImg: "@/assets/eigaland_logo.png",
    };
  },
  computed: {
    ...mapState("app", {
      cinemaId: state => state.cinemaId,
      brandId: state => state.brandId,
      userName: state => state.userName,
      cinemaArr: state => state.cinemaObj,
      originalUserMsg: state => state.originalUserMsg,
    }),
    isLoginPage() {
      return !(this.$route.path === "/" || this.$route.path === "/login");
    },
    userInfo() {
      return Object.keys(this.originalUserMsg).length > 0 ? this.originalUserMsg : localStorage.get("originalUserMsg");
    },
    originalAdmin() {
      const brandName = localStorage.get("brandName");
      return this.userInfo && (this.userInfo.adminType === "superAdmin" && this.cinemaId) ? brandName : (this.userInfo.userName !== this.userName) ? this.userInfo.userName : null;
    },
  },
  methods: {
    ...mapActions("app", [
      "setAppData",
      "logoutAction",
    ]),
    logout() {
      logoutService().then(() => {
        this.logoutAction({});
      });
    },
    backToOriginalAdmin() {
      if (this.userInfo) {
        const { adminType } = this.userInfo;
        if (adminType === "superAdmin" && this.cinemaId) {
          // login to brand for superAdmin login cinema back to login brand case
          this.loginAs(this.brandId);
          localStorage.remove("brandName");
        } else {
          localStorage.remove("loginAsAccountId");
          this.setAppData({ data: this.userInfo });
          setLocalStorage("adminType", adminType);
          if (this.$router.history.current.path !== "/dashboard") {
            this.$router.push("/dashboard");
          }
        }
      }
    },
    loginAs(id) {
      const { cinemaObj } = this.userInfo;
      let newCinemaArr = [];
      let oldCinemaArr = [ ...cinemaObj ];

      if (oldCinemaArr) {
        newCinemaArr = oldCinemaArr.filter(_obj => _obj.brandId === id) || [];
      }

      loginAsBrand({ id }).then(res => {
        if (res.success) {
          const {
            id, userName,
            moduleMap, permissionMap,
            type, admin,
            cinemas, brandId,
          } = res.data;
          setLocalStorage("adminType", type);
          let userInfo = {
            userName,
            cinemas,
            cinemaId: "",
            brandId,
            moduleMap,
            permissionMap,
            adminType: type,
            isAdmin: admin,
            cinemaObj: newCinemaArr,
            loginAsAccountId: id,
          };
          this.setAppData({ data: userInfo });
          getSystemSetting().then(setting_res => {
            const { round, brandCode } = setting_res.data;
            userInfo = {
              ...userInfo,
              round,
              brandCode,
            };
            this.setAppData({ data: userInfo });
            if (this.$router.history.current.path !== "/dashboard") {
              this.$router.push("/dashboard");
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.header {
  min-width: 480px;
  top: 0;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.eiga-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;

  > section {
    display: flex;
    align-items: center;
  }

  .logo {
    width: 200px;

    > a {
      display: inlne-block;

      > img {
        display: block;
        width: 200px;
        height: 100%;
      }
    }
  }

  .nav-bar {
    justify-content: flex-end;
    flex-grow: 1;

    .help-link {
      a {
        color: @primary-black;
        text-decoration: none;

        &:hover {
          color: @primary-orange;
          text-decoration: underline;
        }
      }
    }

    ::v-deep .drop-down-menu {
      margin-right: -20px;

      .user-avatar {
        width: 30px;
        margin: 0 10px;
      }

      .user-name {
        display: inline-block;
        max-width: 300px;
        font-size: 1rem;
        color: @primary-black;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }

      .el-submenu__title i {
        color: @other-grey;
      }

      .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
        border-bottom: none;
      }
    }
  }
}
</style>
